import { isPresent } from '@ember/utils';
import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
const ApplicationFields = ProtoBaseModel.extend({
  appointmentsEmailNotificationSetting: attr(Boolean),
  appointmentsPhoneNotificationSetting: attr(Boolean)
});
export default ApplicationFields;
export const Type = new Enum('EMAIL', 'EMAIL_AND_PHONE', 'NONE', 'PHONE');
export const DEFAULT_TYPE = Type.EMAIL_AND_PHONE;
export const OPTIONS = [{
  type: Type.EMAIL_AND_PHONE,
  key: 'customers.list.detail.appointments.field.notifications.option.emailAndPhone'
}, {
  type: Type.EMAIL,
  key: 'customers.list.detail.appointments.field.notifications.option.email'
}, {
  type: Type.PHONE,
  key: 'customers.list.detail.appointments.field.notifications.option.phone'
}, {
  type: Type.NONE,
  key: 'customers.list.detail.appointments.field.notifications.option.none'
}];
export function applicationFieldsToType(applicationFields) {
  if (!applicationFields) {
    return DEFAULT_TYPE;
  }
  const hasEmail = applicationFields.get('appointmentsEmailNotificationSetting');
  const hasPhone = applicationFields.get('appointmentsPhoneNotificationSetting');
  return isPresent(hasEmail) || isPresent(hasPhone) ? settingsToType(hasEmail, hasPhone) : DEFAULT_TYPE;
}
export function settingsToType(appointmentsEmailNotificationSetting, appointmentsPhoneNotificationSetting) {
  if (appointmentsEmailNotificationSetting && appointmentsPhoneNotificationSetting) {
    return Type.EMAIL_AND_PHONE;
  } else if (appointmentsEmailNotificationSetting) {
    return Type.EMAIL;
  } else if (appointmentsPhoneNotificationSetting) {
    return Type.PHONE;
  } else {
    return Type.NONE;
  }
}
export function typeToKey(type) {
  return OPTIONS.findBy('type', type).key;
}
export function typeToSettings(type) {
  const appointmentsEmailNotificationSetting = type === Type.EMAIL_AND_PHONE || type === Type.EMAIL;
  const appointmentsPhoneNotificationSetting = type === Type.EMAIL_AND_PHONE || type === Type.PHONE;
  return {
    appointmentsEmailNotificationSetting,
    appointmentsPhoneNotificationSetting
  };
}

// Functions for contact editing:

export function copyApplicationFieldsForEditing(contact) {
  const applicationFields = contact.get('applicationFields');
  const original = applicationFields ? ApplicationFields.create(applicationFields.getAllProperties()) : null;
  contact.set('applicationFieldsOriginal', original);
}
export function resetApplicationFields(contact) {
  contact.set('applicationFields', contact.get('applicationFieldsOriginal'));
}